import { useContext, useEffect, useRef } from 'react';

import { ParallaxContext, TParallaxLayerOptions } from './ParallaxContext';

export type TParallaxLayerProps =  Partial<TParallaxLayerOptions> & {
    children: React.ReactNode,
}

const ParallaxLayer = ({
    children,

    $translateOffset = [0, 0, 0],
    $translateOffsetStart = [0, 0, 0],
    $perspective = 500,
}: TParallaxLayerProps) => {
    const context = useContext(ParallaxContext);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        context.addLayer({
            element: ref.current,
            $perspective,
            $translateOffset,
            $translateOffsetStart,
        });
    }, []);

    return (
        <div ref={ref}>
            {children}
        </div>
    );
};

export default ParallaxLayer;
